export default __webpack_public_path__ + "static/media/logo-arc-no-domain.1319f1c1.webp";